export const TipsDistributionBulkRoutesJS = {
    "/tips-distribution": {
        "name": "appLayout.harriSH.tips-distribution",
        "headTags": [],
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("./tips-distribution-bulk.module.js");
                }
            },
            {
                type: 'chunk',
                loader: () => {
                    return import("./tips-distribution-shared.module.js");
                }
            },
        ]
    },
};